import script from "./index.vue?vue&type=script&setup=true&name=header&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=header&lang=js"

import "./index.vue?vue&type=style&index=0&id=f7522d46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7522d46"]])

export default __exports__